import closeIconSvg from '../../../assets/svg/UI/close.svg';

import editTaskInstanceUrl from './editTaskInstance.html';

class EditTaskInstanceCtrl {
  closeIconSvg = closeIconSvg;

  constructor(ShiftTasksService, sdk, $state) {
    'ngInject';

    Object.assign(this, { ShiftTasksService, sdk, $state });

    this.TASK_INSTANCE_PENDING_STATUS = sdk('constants').TASK_INSTANCE_PENDING_STATUS;

    this.alwaysopen = true;
  }

  $onInit() {
    this.loadTaskInstanceDetails();
  }

  async loadTaskInstanceDetails() {
    try {
      const taskInstance = await this.ShiftTasksService.loadTaskInstanceDetails(
        this.taskInstanceId
      );
      this.setTaskInstanceDetails(taskInstance);
    } catch (e) {
      this.dismiss();
    }
  }

  setTaskInstanceDetails(taskInstance) {
    if (!taskInstance.subtasks?.length) {
      taskInstance.subtasks = [{ title: '', status: this.TASK_INSTANCE_PENDING_STATUS }];
    }
    this.taskInstance = {
      ...taskInstance,
      subtasks: taskInstance.subtasks.map((subtask) => ({ ...subtask })),
    };
  }

  dismiss() {
    this.modal.dismiss();
  }

  async submit(taskInstance) {
    if (this.form.$invalid) {
      this.form.$setSubmitted();
      throw 'Task form is not valid';
    }
    const result = await this.ShiftTasksService.editTaskInstance(taskInstance);
    this.modal.close(result);
  }

  updateSubtasks(subtasks) {
    this.form.$setDirty();
    this.taskInstance.subtasks = subtasks;
  }
}

export default {
  templateUrl: editTaskInstanceUrl,
  controller: EditTaskInstanceCtrl,
  controllerAs: 'ctrl',
  bindings: {
    modal: '<',
    taskInstanceId: '<',
  },
};
